import { Codespan, Del, Em, Escape, HTML, Image, Link, Strong, Tag, Text } from './Tokens';

/**
 * TextRenderer
 * returns only the textual part of the token
 */
export class _TextRenderer<RendererOutput = string> {
  // no need for block level renderers
  strong({ text }: Strong): RendererOutput {
    return text as RendererOutput;
  }

  em({ text }: Em): RendererOutput {
    return text as RendererOutput;
  }

  codespan({ text }: Codespan): RendererOutput {
    return text as RendererOutput;
  }

  del({ text }: Del): RendererOutput {
    return text as RendererOutput;
  }

  html({ text }: HTML | Tag): RendererOutput {
    return text as RendererOutput;
  }

  text({ text }: Text | Escape | Tag): RendererOutput {
    return text as RendererOutput;
  }

  link({ text }: Link): RendererOutput {
    return ('' + text) as RendererOutput;
  }

  image({ text }: Image): RendererOutput {
    return ('' + text) as RendererOutput;
  }

  br(): RendererOutput {
    return '' as RendererOutput;
  }
}
